import { type FC } from "react";
import { Card, Spinner } from "@chakra-ui/react";

export const LoadingStateScreen: FC<Card.RootProps> = () => {
  return (
    <Card.Root
      rounded="none"
      shadow="none"
      justifyContent="center"
      alignItems="center"
      display="flex"
      height="100vh"
    >
      <Spinner size="xl" />
    </Card.Root>
  );
};
